export default {"src":"/_next/static/media/Cool.37aa3398.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};